<div *ngIf="applicationStatus() as details"
     class="status-badge"
     [ngClass]="details.color">
  {{ details.status }}
  @if (buildingApplicationItemDto().status == ApplicationStatus.Rejected) {
    <nb-icon
      icon="info-outline"
      pack="eva"
      class="info-icon"
      [nbTooltip]="buildingApplicationItemDto().rejectComment ?? ''">
    </nb-icon>
  }
</div>
